(function(){
    angular
        .module('appback')
        .directive('ngTablabioq', ngTablabioq);

        ngTablabioq.$inject = ['socket','$timeout'];
        function ngTablabioq(socket,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/pendientes/gettemplate?name=tablabioq.twig',
		        scope: {
                    mc:'=',
                    lc:'=',
                    categoriaid:'='
                  //ngModel : '=',
                  //rc: '=',
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.isAnaliticaVisible = function(analitica,categoriaid){
                            //console.log("analitica",analitica);
                            //console.log("categoriaid",categoriaid);
                            var res = false;
                            var categoriaListaId = analitica.analitica.categorialista_id;
                            // Convertir a array si no lo es
                            if (!Array.isArray(categoriaListaId)) {
                                categoriaListaId = [categoriaListaId];
                            }
                            if (categoriaListaId.includes(categoriaid)) {
                                res = true;
                            }
                            return res;
                        }
                        //console.log("scope",scope);
			        });
		        }
          }
      }
})();